import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Agency from '../entities/agency';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface AgencyState extends ListState<Agency> {
  agency: Agency;
  editAgency: Agency;
  select: Agency;

}

class AgencyMutations extends ListMutations<Agency> { }

class AgencyModule extends ListModule<AgencyState, any, Agency> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Agency>(),
    loading: false,
    editAgency: new Agency(),
    selectAgency: new Agency(),
  };
  actions = {
    async selectAgency(context: ActionContext<AgencyState, any>, payload: any) {
      context.state.editAgency = payload.data;
    },

    async saveAgency(context: ActionContext<AgencyState, any>, payload: any) {
      let reponse = await Ajax.post(
        '/api/services/app/Agency/SaveOrUpdateAgency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Agency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateAgency(context: ActionContext<AgencyState, any>, payload: any) {
      let reponse = await Ajax.put(
        '/api/services/app/Agency/UpdateAgency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Agency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAgency(context: ActionContext<AgencyState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get('/api/services/app/Agency/GetAgencyInfo');
      context.state.loading = false;
      let agency = reponse.data.result as Agency;
      context.state.select = agency;
    },

    async deleteAgency(context: ActionContext<AgencyState, any>, payload: any) {
      await Ajax.delete(
        '/api/services/app/Agency/DeleteAgency?id=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: AgencyState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AgencyState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const agencyModule = new AgencyModule();
export default agencyModule;
